import { LoginForm } from 'mk2/apps/users/components/LoginForm';
import { SignupLoginWrapper } from 'mk2/apps/users/components/SignupLoginWrapper';
import { Props } from 'mk2/apps/users/containers/Login/LoginPage';
import { parse } from 'query-string';
import React from 'react';
import styles from './Login.mscss';

export default class Login extends React.Component<Props> {

    public componentDidMount() {
        const { onCheckOneTimeLoginLink, location } = this.props;
        const q = parse(location.search);
        const otl = q.otl as string;
        if (otl) {
            onCheckOneTimeLoginLink(otl);
        }
    }

    public render() {
        const { currentFormPage, initialValues, isMobile, location, onLogin } = this.props;

        return (
            <SignupLoginWrapper className={styles.Login} qs={location.search} isMobile={isMobile} currentFormPage={currentFormPage}>
                <LoginForm
                    initialValues={initialValues}
                    onLogin={onLogin}
                />
            </SignupLoginWrapper>
        );
    }
}
